import React from 'react';
import {Link} from 'react-router-dom';
import { Header } from '../Common/Header';
import { Footer } from '../Common/Footer';
import Pagination from "react-js-pagination";
class CategoriesGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
        }
    }
    handlePageChange(pageNumber) {
        console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });
    }
    render() {
        return (
            <div>
                <div className="container">
                    <Header />
                </div>
                <div className="container-fluid">
                    {/* <div className="container"> */}
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"> </div>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-1">
                            </div>

                            <div className="col-md-10">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="lined_text">
                                            path
                                            </div>
                                    </div>
                                    <div className="col-md-9"></div>
                                </div>
                            </div>

                            <div className="col-md-1"></div>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-1">
                            </div>
                            <div className="col-md-10">
                                <div className="row">
                                    <div className="col-md-3 remember_text">
                                        <div className="pro">
                                            <div className="row">
                                                <div className="col-md-3">

                                                    <img src={require("../../assets/images/pro.png")} className="img-responsive" alt="" width="100%" height="80%" />
                                                </div>
                                                <div className="col-md-9">

                                                    <b> Prioritize PRO certification</b>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="cat_name_common1">
                                            > All Categories
                                                            </div>
                                        <div className="cat_name_common1">
                                            design
                                                            </div>
                                        <div className="cat_name_common2">
                                            Logo creation / design
                                                            </div>
                                        <div className="cat_name_common2">
                                            Flyer creation / flyer design
                                                            </div>
                                        <div className="cat_name_common2">
                                            Map making, guide map making
                                                            </div>
                                        <div className="cat_name_common2">
                                            Catalog / brochure design
                                                            </div>
                                        <div className="cat_name_common2">
                                            Business card creation / various card designs
                                                </div>
                                        <div className="cat_name_common2">
                                            Menu · POP · label design
                                                            </div>
                                        <div className="cat_name_common2">
                                            Drawing, CAD, Perspective, CG creation
                                                            </div>
                                        <div className="cat_name_common2">
                                            CD and book design
                                                            </div>
                                        <div className="cat_name_common2">
                                            Letter design, calligraphy writing
                                                            </div>
                                        <div className="cat_name_common2">
                                            Package and packaging design
                                                            </div>
                                        <div className="cat_name_common2">
                                            Poster, signboard design
                                                            </div>
                                        <div className="cat_name_common2">
                                            Wedding, anniversary, goods design
                                                            </div>
                                        <div className="cat_name_common2">
                                            Product design
                                                            </div>
                                        <div className="cat_name_common2">
                                            Design data correction and conversion
                                                            </div>
                                        <div className="cat_name_common2">
                                            How to use design consultation and tools
                                                            </div>
                                        <div className="cat_name_common2">
                                            Other (design)
                                                            </div>
                                        <div>&nbsp;</div>
                                        <div className="types">
                                            <span className="types_pad">Service Type</span>
                                            <div className="radio">
                                                <label><input className="mr-1" type="radio" name="optradio" checked />Normal service</label>
                                            </div>
                                            <div className="radio">
                                                <label><input className="mr-1" type="radio" name="optradio" checked />Telephone consultation service</label>
                                            </div>
                                        </div>
                                        <div className="types">
                                            <span className="types_pad">Refine Options</span>
                                            <div className="checkbox">
                                                <label><input className="mr-1" type="checkbox" value="" />Estimated and customizable</label>
                                            </div>
                                            <div className="checkbox">
                                                <label><input className="mr-1" type="checkbox" value="" />PRO certified</label>
                                            </div>
                                            <div className="checkbox">
                                                <label><input className="mr-1" type="checkbox" value="" />Goods can be delivered</label>
                                            </div>
                                            <div className="checkbox">
                                                <label><input className="mr-1" type="checkbox" value="" />Use video chat</label>
                                            </div>
                                        </div>
                                        <div className="types">
                                            <span className="types_pad">Keywords</span>
                                            <div>
                                                <input type="text" value="" className="rounded" />
                                            </div>
                                        </div>
                                        <div className="top_bottom_padding">
                                            <span className="types_pad">Price</span>
                                            <div className="top_bottom_padding">
                                                <table >
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <select className="services_filters">
                                                                    <option />
                                                                </select>
                                                            </td>
                                                            <td>
                                                                ~
                                                                    </td>
                                                            <td>
                                                                <select className="services_filters">
                                                                    <option />
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="top_bottom_padding">
                                            <span className="types_pad">Delivery Date</span>
                                            <div className="top_bottom_padding">
                                                <select className="services_filters">
                                                    <option />
                                                </select>
                                            </div>
                                        </div>
                                        <div className="top_bottom_padding">
                                            <span className="types_pad">Certification status</span>
                                            <div className="top_bottom_padding">
                                                <div className="checkbox">
                                                    <label><input className="mr-1" type="checkbox" value="" />Confirmed identity</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="directional_text">
                                            <button type="button" className="agree_button">Search Under This Condition</button>
                                        </div>
                                    </div>

                                    <div className="col-md-9 large_fonts">
                                        <div className="col-md-12">
                                            <img alt="" src={require("../../assets/images/logo_icon.jpg")} height="50" />&nbsp;Logo Creation/Design
                                            </div>
                                        <div className="product_text">
                                            Congrats! I made a logo with my heart in mind ☆ Create a high quality design by Osumibu has been purchased.20 hours ago
                                            </div>
                                        <div className="some_of_total" >
                                            <span>1-40 of 1343 items</span>
                                        </div>
                                        <div className="product_sortings">
                                            <Link to={'#'} className="blue_text mr-5">Ranking</Link><Link to={'#'} className="blue_text">Order by number of favourites</Link>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-3 ">
                                                <div className="categories_grid">
                                                    <img src={require('../../assets/images/image1.jpeg')} height="160" width="100%" alt="" />
                                                    <div className="m-2">
                                                        <div className="categories_grid_text">
                                                            Congrats! I made a logo with my heart in mind
                                                            </div>
                                                        <div className="categories_grid_seller">
                                                            Mr.agdfhsdf
                                                            </div>
                                                        <div className="categories_price">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <span className="fas-fa-star"></span>
                                                                </div>
                                                                <div className="col-md-6 pl-5">
                                                                    5000 Yen
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="categories_grid">
                                                    <img src={require('../../assets/images/image1.jpeg')} height="160" width="100%" alt="" />
                                                    <div className="m-2">
                                                        <div className="categories_grid_text">
                                                            Congrats! I made a logo with my heart in mind
                                                            </div>
                                                        <div className="categories_grid_seller">
                                                            Mr.agdfhsdf
                                                            </div>
                                                        <div className="categories_price">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <span className="fas-fa-star"></span>
                                                                </div>
                                                                <div className="col-md-6 pl-5">
                                                                    5000 Yen
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 ">
                                                <div className="categories_grid">
                                                    <img src={require('../../assets/images/image1.jpeg')} height="160" width="100%" alt="" />
                                                    <div className="m-2">
                                                        <div className="categories_grid_text">
                                                            Congrats! I made a logo with my heart in mind
                                                            </div>
                                                        <div className="categories_grid_seller">
                                                            Mr.agdfhsdf
                                                            </div>
                                                        <div className="categories_price">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <span className="fas-fa-star"></span>
                                                                </div>
                                                                <div className="col-md-6 pl-5">
                                                                    5000 Yen
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="categories_grid">
                                                    <img src={require('../../assets/images/image1.jpeg')} height="160" width="100%" alt="" />
                                                    <div className="m-2">
                                                        <div className="categories_grid_text">
                                                            Congrats! I made a logo with my heart in mind
                                                            </div>
                                                        <div className="categories_grid_seller">
                                                            Mr.agdfhsdf
                                                            </div>
                                                        <div className="categories_price">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <span className="fas-fa-star"></span>
                                                                </div>
                                                                <div className="col-md-6 pl-5">
                                                                    5000 Yen
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4"></div>
                            <div className="col-md-6 ml-5">
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={10}
                                    totalItemsCount={450}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                    </div>
                    {/* </div> */}
                </div>
                <Footer />
            </div>
        )
    }
}
export { CategoriesGrid }